import { render, staticRenderFns } from "./MailConfirmationFailed.vue?vue&type=template&id=0f0ec314"
import script from "./MailConfirmationFailed.vue?vue&type=script&lang=js"
export * from "./MailConfirmationFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports